<script lang="ts">

  import type { Documentation, RealizationForm } from "../../_types"

  import DialogFormDocumentation from "./dialog-form-documentation.svelte"

  let {
    open,
    setOpen,
    value,
    save,
    remove,
  }: {
    open: boolean
    setOpen: (open: boolean) => void
    value: Documentation
    save: (value: RealizationForm["documentation_others"][number]) => void
    remove: (value: Documentation) => void
  } = $props()

</script>

<DialogFormDocumentation
  open={open}
  setOpen={setOpen}
  value={value}
  save={save}
  remove={remove}/>
